import * as reducers from './reducers';
import {ActionReducerMap} from '@ngrx/store';

export interface AppState {
//  evaluaciones: reducers.EvaluacionesState
}

export const appReducers: ActionReducerMap<AppState> = {
  //evaluaciones: reducers.evaluacionesReducer
};
